import { render } from "./receivePackage.vue?vue&type=template&id=15b71989&scoped=true"
import script from "./receivePackage.vue?vue&type=script&lang=js"
export * from "./receivePackage.vue?vue&type=script&lang=js"

import "./receivePackage.vue?vue&type=style&index=0&id=15b71989&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b71989"]])

export default __exports__